import { buildCoverSheetConfig } from '../../shared';
import { BaseTenantConfig, type TenantLocaleOverrides } from './base';
import { overrides } from './overrides';

/**
 * Builds the coversheet config for a tenant lease.
 * @param locale Locale code, e.g. CA
 * @returns Coversheet config for specified locale
 */
export function buildTenantCoverSheetConfig(locale: string) {
  const localeOverrides: TenantLocaleOverrides = overrides[locale] ?? {
    locale,
  };
  return buildCoverSheetConfig(BaseTenantConfig, localeOverrides);
}
